import React from 'react'
import { useFormContext, Controller } from 'react-hook-form'
import { Box, FormLabel, Switch, Typography } from '@material-ui/core'

import useStyles from './styles'
import theme from 'theme'

const CompactModeCustomization = () => {
  const classes = useStyles()
  const { control } = useFormContext()

  return (
    <Box
      display="flex"
      flexDirection="column"
      gridGap={theme.spacing(1)}
      width="100%"
    >
      <FormLabel className={classes.formLabel} color="primary">
        Modo Compacto
      </FormLabel>
      <Box display="flex" alignItems="center" gridGap={theme.spacing(1)}>
        <Controller
          control={control}
          name="isCompact"
          onChange={([, checked]) => checked}
          as={<Switch color="primary" />}
        />
        <Typography className={classes.switchLabel}>
          Exibir o banner em formato compacto
        </Typography>
      </Box>
    </Box>
  )
}

export default CompactModeCustomization
